import emailjs from "@emailjs/browser";


export const sendEmail = async (formData, type, serviceID) => {
  console.log("sendEmail formData", formData);
  const { firstName, lastName, email, phone, message } = formData;
  const fullName = `${firstName || ""} ${lastName || ""}`.trim();

  // Define template IDs for different email types
  const templateIds = {
    welcome: "TMP_Welcome",
    prayer: "TMP_Prayer_Request",
    prayerReply: "TMP_Prayer_Reply",
    prayerReplyMarian: "TMP_Prayer_Marian",
    contact: "TMP_Default",
    prayer_ga: "TMP_Default",
    sabbath_request: "TMP_Sabbath_Request",
    TMP_Sabbath_Approval: "TMP_Sabbath_Approval",
    retreat: "TMP_Retreat_Reg",
    retreatApproval: "TMP_Retreat_Approval",
    retreatCancel: "TMP_Default",
    default: "TMP_Default",
    TMP_Default: "TMP_Default",
    TMP_Waiver: "TMP_Waiver",
    TMP_Retreat_Registration: "TMP_Retreat_Registration",
  };

  // Set parameters based on the type of email
  let templateParams;
  let selectedServiceId = serviceID
    ? serviceID
    : process.env.REACT_APP_EMAILJS_SERVICE_ID;
  switch (type) {
    case "welcome":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
      templateParams = {
        to_name: firstName || " " || lastName,
        phone: phone,
        from_name: "Grace Anointing Team",
        from_email: process.env.REACT_APP_EMAILJS_DEFAULT_EMAIL_ID,
        to_email: email,
        message: "Welcome",
      };
      break;
    case "prayer":
      templateParams = {
        to_name: fullName,
        phone: phone,
        from_name: "Grace Anointing Team",
        to_email: email,
        message: message,
      };
      break;
    case "prayerReply":
      templateParams = {
        to_name: fullName,
        to_email: email,
        replyMessage:
          formData.replyMessageInLang || formData.replyMessage || "",
      };
      break;
    case "prayerReplyMarian":
      templateParams = {
        to_name: fullName,
        to_email: email,
        messageFromMarian:
          formData.messageFromMarianInLang || formData.messageFromMarian || "",
      };
      break;
    case "contact":
      templateParams = {
        from_name: fullName,
        to_name: "Grace Anointing Team",
        to_email: process.env.REACT_APP_EMAILJS_DEFAULT_EMAIL_ID,
        from_email: email,
        phone: phone,
        preMessage:
          type === "contact"
            ? "Please read the below message and respond accordingly."
            : "Please pray for the below request.",
        message: message,
        subject: type === "contact" ? "Contact Request" : "Prayer Request",
      };
      break;
    case "prayer_ga": // not using
      templateParams = {
        from_name: fullName,
        to_name: "Grace Anointing Prayer Team",
        to_email: process.env.REACT_APP_EMAILJS_PRAYER_EMAIL_ID,
        from_email: email,
        phone: phone,
        preMessage:
          type === "contact"
            ? "Please read the below message and respond accordingly."
            : "Please pray for the below request.",
        message: message,
        subject: type === "contact" ? "Contact Request" : "Prayer Request",
      };
      break;

    case "sabbath_request":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID_SABBATH;
      templateParams = {
        from_name: "Grace Anointing Sabbath Team",
        to_name: fullName,
        to_email: email,
        from_email: "sabbath@graceanointing.org",
        phone: phone,
        message: message,
      };
      break;

    case "TMP_Sabbath_Approval":
      selectedServiceId = process.env.REACT_APP_EMAILJS_SERVICE_ID_SABBATH;
      templateParams = formData;
      break;
    case "retreat":
      templateParams = formData;
      break;
    case "retreatApproval":
      templateParams = formData;
      break;
    case "retreatCancel":
      templateParams = {
        from_name: "Grace Anointing Retreat Team",
        to_name: formData.fullName,
        to_email: formData.email,
        cc_email: formData.cc_email,
        from_email: "retreat@graceanointing.org",
        phone: "",
        subject: "Retreat Registration Status Changed to " + formData.status,
        message:
          "Your retreat registration for the Retreat " +
          formData.retreatName +
          " with Registration ID : " +
          formData.registrationID +
          " has been cancelled.",
      };
      break;
    case "default":
      templateParams = formData;
      break;
    case "TMP_Default":
      templateParams = formData;
      break;
    default:
      templateParams = formData;
      break;
  }

  // Select the template ID based on type or use a default template
  let selectedTemplateId = templateIds[type];

  console.log("Selected Template ID:", selectedTemplateId);

  console.log("selectedServiceId:", selectedServiceId);
  // Send the email via emailjs
  if (!selectedTemplateId) {
    selectedTemplateId = type;
  }
  console.log("Selected Template ID:", selectedTemplateId);
  console.log("templateParams:", templateParams);
  try {
    const response = await emailjs.send(
      selectedServiceId || process.env.REACT_APP_EMAILJS_SERVICE_ID,
      selectedTemplateId,
      templateParams,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    );
    console.log("Email sent successfully!", response.status, response.text);
    return { success: true, status: response.status, text: response.text };
  } catch (error) {
    console.error("Email JS sending failed...");
    console.error(":", JSON.stringify(error));
    console.error(".................");
    const errorMessage = error && error.message ? error.message : JSON.stringify(error);
    console.error("Error details:", errorMessage);
    console.error(".................");
      // Optional: try extracting more detail
  if (error?.response?.status) {
    console.error("🔍 Status code:", error.response.status);
    console.error("🔍 Error text:", error.response.text || error.response.statusText);
  }
    return { success: false, error: errorMessage };
  }
};
